import { Directive, ElementRef, Input, inject } from '@angular/core';
import { booleanAttribute } from '@angular/core';

@Directive({
  selector: '[appCanAutoFocus]',
})
export class CanAutoFocusDirective {
  private readonly _host = inject(ElementRef<HTMLElement>);

  @Input({ alias: 'appCanAutoFocus', transform: booleanAttribute })
  set canAutoFocus(value: boolean) {
    if (!value) return;
    queueMicrotask(() => this._host.nativeElement.focus());
  }
}
